import React, { useState, useEffect } from 'react';
import style from './CaseStudyPromo.module.scss';
import LottieAnimation from '../LottieAnimation';
import Player from '../Player';

const CaseStudyPromo = component => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    // Load data on component mount
    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                // Simulate API call delay
                await new Promise(resolve => setTimeout(resolve, 100));

                setData(component);
            } catch (error) {
                setData(null);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [component]);

    const handleVideoClick = () => {
        if (hero.video) {
            setIsVideoPlaying(true);
        }
    };

    const handleVideoClose = () => {
        setIsVideoPlaying(false);
    };

    const videoOnPlay = () => {
        setIsVideoPlaying(true);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!data) {
        return null;
    }

    // Destructure data
    const { hero = {}, leftContent = {}, rightContent = {} } = data;
    return (
        <div className={[style.caseStudyPromo, 'container'].join(' ')}>
            {/* Hero Section - InnerPageHeader with Play Button Overlay */}
            {hero && (
                <div className={`${style.heroSection} ${!hero.title || !hero.cta ? style.heroSectionNoContent : ''}`}>
                    <img src={hero.image.url} alt="" layout="fill" />
                    {/* Play Button Overlay for Video */}
                    {hero.video && hero.video && (
                        <div className={style.playButtonOverlay} onClick={handleVideoClick}>
                            <button type='button' className={style.playButton}>
                                <img src='/images/people/play.png' alt='play' />
                            </button>
                        </div>
                    )}
                </div>
            )}
            {/* Video Modal */}
            {isVideoPlaying && hero.video && (
                <div className={style.videoModal} onClick={handleVideoClose}>
                    <div className={style.videoModalContent} onClick={e => e.stopPropagation()}>
                        <button className={style.closeButton} onClick={handleVideoClose}>
                            ×
                        </button>
                        <Player link={hero.video} poster={hero.image?.url} isAutoPlay={true} onPlay={videoOnPlay} />
                    </div>
                </div>
            )}
            {/* Two Column Layout */}
            <div className={style.twoColumnLayout}>
                {/* Left Column - Icon with Text */}
                <div className={style.leftColumn}>
                    {leftContent && (
                        <div className={style.iconSection}>
                            {/* Icon with Animation */}
                            {leftContent.icon && (
                                <div className={style.iconContainer}>
                                    {leftContent.icon.animationJson ? (
                                        <LottieAnimation
                                            json={leftContent.icon.animationJson}
                                            className={style.lottieIcon}
                                            playImmediately={false}
                                        />
                                    ) : leftContent.icon.image && leftContent.icon.image.url ? (
                                        <img
                                            src={leftContent.icon.image.url}
                                            alt={leftContent.icon.image.alt || 'Icon'}
                                            className={style.fallbackIcon}
                                        />
                                    ) : null}
                                </div>
                            )}
                            {leftContent.title && (
                                <div className={style.iconText} dangerouslySetInnerHTML={{ __html: leftContent.title }} />
                            )}
                            {leftContent.body && (
                                <div className={style.bodyText} dangerouslySetInnerHTML={{ __html: leftContent.body }} />
                            )}
                        </div>
                    )}
                </div>
                <div className={style.rightColumn}>
                    {rightContent && (
                        <div className={style.rightContent}>
                            {rightContent.image && rightContent.image.url && (
                                <div className={style.imageContainer}>
                                    <img src={rightContent.image.url} alt={rightContent.image.alt || 'Image'} className={style.contentImage} />
                                </div>
                            )}
                            {rightContent.title && <div className={style.bodyText} dangerouslySetInnerHTML={{ __html: rightContent.title }} />}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

CaseStudyPromo.propTypes = {
    // Component now receives all props directly
};

export default CaseStudyPromo;
